import { DefaultButtonContainer } from "./styles";

interface IDefaultButtonProps {
	children: React.ReactNode;
	params?: any;
	withOutBackground?: boolean;
	marginTop?: string;
	width?: string;
	minWidth?: string;
	marginLeft?: string;
	height?: string;
	fontSize?: string;
	padding?: string;
	onMobileFullWidth?: boolean;
}

function DefaultButton(props: IDefaultButtonProps): JSX.Element {
	return (
		<DefaultButtonContainer
			withOutBackground={props.withOutBackground}
			marginTop={props.marginTop}
			width={props.width}
			height={props.height}
			fontSize={props.fontSize}
			padding={props.padding}
			onMobileFullWidth={props.onMobileFullWidth}
			minWidth={props.minWidth}
			marginLeft={props.marginLeft}
			{...props.params}
		>
			{props.children}
		</DefaultButtonContainer>
	);
}
export default DefaultButton;